import { __assign } from "tslib";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import OptionsList from "../../internal/components/options-list";
import React, { forwardRef, useImperativeHandle } from "react";
import { renderOptions } from "../utils/render-options";
import { scrollElementIntoView } from "../../internal/utils/scrollable-containers";
import styles from "./styles.css.js";
var PlainList = function(_a, ref) {
    var menuProps = _a.menuProps, getOptionProps = _a.getOptionProps, filteredOptions = _a.filteredOptions, filteringValue = _a.filteringValue, highlightType = _a.highlightType, checkboxes = _a.checkboxes, hasDropdownStatus = _a.hasDropdownStatus, listBottom = _a.listBottom, useInteractiveGroups = _a.useInteractiveGroups, screenReaderContent = _a.screenReaderContent;
    var menuRef = menuProps.ref;
    useImperativeHandle(ref, function() {
        return function(index) {
            var _a;
            var item = (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('[data-mouse-target="'.concat(index, '"]'));
            if (highlightType === "keyboard" && item) {
                scrollElementIntoView(item);
            }
        };
    }, [
        highlightType,
        menuRef
    ]);
    return /*#__PURE__*/ React.createElement(OptionsList, __assign({}, menuProps), renderOptions({
        options: filteredOptions,
        getOptionProps: getOptionProps,
        filteringValue: filteringValue,
        highlightType: highlightType,
        checkboxes: checkboxes,
        hasDropdownStatus: hasDropdownStatus,
        useInteractiveGroups: useInteractiveGroups,
        screenReaderContent: screenReaderContent
    }), listBottom ? /*#__PURE__*/ React.createElement("li", {
        role: "option",
        className: styles["list-bottom"]
    }, listBottom) : null);
};
export default /*#__PURE__*/ forwardRef(PlainList); //# sourceMappingURL=plain-list.js.map
